import { EXERCISE_KEY } from '@gymaholic/packages'
import TextTitleCondensed from 'components/TextTitleCondensed'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import React from 'react'

export default function SetRowTitle ({
  exercise,
  isRest,
  setIndex
}) {
  const renderName = () => {
    if (isRest) {
      return 'Rest'
    }

    if (setIndex !== undefined) {
      return `Set ${setIndex + 1}`
    }

    return getValueReduxUtil(exercise, EXERCISE_KEY.NAME)
  }

  return (
    <TextTitleCondensed
      c='#151D21'
      fw='700'
      fs='1.25em'
      style={{ textTransform: 'uppercase' }}
    >
      {renderName()}
    </TextTitleCondensed>
  )
}
